<template>
  <div class="container">
    <HomeCategories :link="cityHomeLink"></HomeCategories>
    <div class="wrapper">
      <div class="sidebar desktopView">
        <LeftSideBar></LeftSideBar>
      </div>
      <div class="main container-fluid">

        <router-view />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import LeftSideBar from "../components/SidebarComponent.vue";
import Footer from "../components/Footer";
import SearchComponent from "../components/SearchComponent";
import HomeCategories from "@/components/HomeCategoriesComponent";

export default {
  metaInfo() {
    return {
      link: [
        {
          once: true,
          rel: "canonical",
          href: "https://www.99huaren.com"
        }
      ]
    };
  },
  data: function() {
    return {
      cityHomeLink: ""
    };
  },
  computed: {
    ...mapState(["cities"]),
  },
  components: {
    HomeCategories,
    Footer,
    LeftSideBar: LeftSideBar,
  },
  methods: {
    ...mapMutations([
      "changeCurrentCategory",
      "setUrls",
      "setCities",
      "setCity"
    ]),
    setCurrentCategory: function() {
      let pathname = window.location.pathname;
      this.categoryId = pathname.match(/categories\/(.*)$/)[1];
      this.changeCurrentCategory(this.categoryId);
    },
    goToCategory: function(index) {
      this.$router.push("/categories/" + index);
    },
    setCityFromUrl: function() {
      var cityIds = this.cities.map(function(c) {
        return c.id;
      });
      let s = location.hostname.split(".99huaren");
      if (localStorage.getItem("city") !== s[0] && cityIds.includes(s[0])) {
        localStorage.setItem("city", s[0]);
      }
      this.setCity(s[0]);
    }
  },
  beforeMount() {
    this.setCurrentCategory();
  },
  mounted: function() {
    if (this.categoryId) {
      this.setUrls({
        topicsUrl: "/categories/" + this.categoryId,
        tagsUrl: "/categories/" + this.categoryId + "/tags"
      });
    } else {
      this.setUrls({
        topicsUrl: "/topics/",
        tagsUrl: "/tags/"
      });
    }
    this.cityHomeLink = window.location.origin + "/";

    if (!this.cities) {
      this.$axios.get("/cities").then(res => {
        this.setCities(res.data);
        this.setCityFromUrl();
      });
    } else {
      this.setCityFromUrl();
    }
  }
};
</script>
